import { Element } from "@craftjs/core";
import React from "react";

import Container from "components/general/Container";
import Section from "components/general/Section";
import { Box } from "components/ui";
import { PageRichTextEditor } from "./PageRichTextEditor";

export const TwoColumnContainer = ({ children, ...props }: any) => {
	return <Box {...props}>{children}</Box>;
};
export const TwoColumnRichText = ({ children, ...props }: any) => {
	return (
		<Box {...props} style={{ padding: "10px 0" }}>
			{children}
		</Box>
	);
};

export const PageTwoColumn = ({ background, padding = 20, isInverted, imageUrl, ...props }: any) => {
	return (
		<Box bg="$neutral25">
			<Container>
				<Section gap={24} flexDirection={isInverted ? "row-reverse" : "row"}>
					<Box justifyContent="center" style={{ flex: 1 }}>
						<Element canvas id="two-column-rich-text-left" is={TwoColumnRichText}>
							<PageRichTextEditor />
						</Element>
					</Box>

					<Box flex={1}>
						<Element canvas id="two-column-rich-text-right" is={TwoColumnRichText}>
							<PageRichTextEditor />
						</Element>
					</Box>
				</Section>
			</Container>
		</Box>
	);
};
